import { useGetFeatureEnabledForCountry } from './useGetFeatureEnabledForCountry';

export default function useIsPremiumFiltersEnabled(): boolean {
  const { isVIPMembershipEnabled } = useGetFeatureEnabledForCountry();

  return isVIPMembershipEnabled;
}
